import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useAuth() {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s);
      if (s) loadProfile(s.user.id);
      else setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s);
      if (s) loadProfile(s.user.id);
      else { setProfile(null); setLoading(false); }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function loadProfile(uid) {
    const { data } = await supabase.from('profiles').select('*').eq('id', uid).single();
    setProfile(data);
    setLoading(false);
  }

  async function login(email, password) {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
  }

  async function logout() {
    await supabase.auth.signOut();
    setSession(null);
    setProfile(null);
  }

  async function setPassword(password) {
    const { error } = await supabase.auth.updateUser({ password });
    if (error) throw error;
    if (profile && !profile.password_set) {
      await supabase.from('profiles').update({ password_set: true }).eq('id', profile.id);
      setProfile(p => ({ ...p, password_set: true }));
    }
  }

  async function sendPasswordReset(email) {
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) throw error;
  }

  async function updateProfile(updates) {
    if (!profile) return;
    const { error } = await supabase.from('profiles').update(updates).eq('id', profile.id);
    if (error) throw error;
    setProfile(p => ({ ...p, ...updates }));
  }

  return {
    session,
    profile,
    loading,
    login,
    logout,
    setPassword,
    sendPasswordReset,
    updateProfile,
    loadProfile,
  };
}
